import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Drawer, Table } from 'antd';
import { toISTDate } from '@Apis/constants';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import PaymentOutgoingActions from '@Actions/paymentOutgoingActions';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ViewPayment from '@Components/Common/ViewPayment';
import Helpers from '@Apis/helpers';
import './style.scss';

/**
 * @param status
 */
class PayoutsList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      column: [
        {
          title: 'DATE',
          render: (record) => toISTDate(record?.payment_date).format('DD/MM/YYYY'),
        },
        {
          title: 'PAYMENT #',
          dataIndex: 'payment_id',
        },
        {
          title: 'REFERENCE #',
          dataIndex: 'utr_number',
        },
        {
          title: 'MODE',
          render: (text, record) => `${record?.paid_through_account_details?.account_name || '-'}`,
        },
        {
          title: 'PAYMENT STATUS',
          render: (text, record) => <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(record.payment_status).color }}>{Helpers.getStatusColor(record.payment_status).text}</div>,
        },
        {
          title: 'APPROVAL STATUS',
          render: (text, record) => <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(record.approval_status).color }}>{Helpers.getStatusColor(record.approval_status).text}</div>,
        },
        {
          title: 'AMOUNT',
          dataIndex: 'due_at',
          render: (text, record) => this.props.MONEY(record?.amount || '0'),
        },
        {
          title: 'ATTACHMENTS',
          render: (text, record) => (
            <div className="min-width-100">
              {
                record?.attachments?.map((item, index) => (
                  <div>
                    <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                  </div>
                ))
              }
            </div>
          )
        },
        {
          title: 'UNUSED AMOUNT',
          dataIndex: 'due_at',
          render: (text, record) => this.props.MONEY(record?.unused_amount || '0'),
        },

        {
          title: 'CREATED BY',
          render: (record) => (
            <Fragment>
              <H3Text text={`${record?.created_by_info?.first_name || ''} ${record?.created_by_info?.last_name || ''}`} className="payout-table__created-by-name" />
              <H3Text text={toISTDate(record?.created_at).format('DD/MM/YYYY')} className="table-subscript" />
            </Fragment>
          ),
        },
        {
          title: '',
          render: (record) => (
            <div style={{
              textAlign: 'center', display: 'flex', justifyContent: 'center', aliignItems: 'center',
            }}
            >
              <div
                className="view-vendor-payout__table__view-button"
                onClick={() => {
                  this.setState({ showViewPayout: true, selectedPayment: record });
                }}
              >
                View
              </div>
            </div>
          ),

        },
      ],
      showSeletedPayout: false,
      currentPage: 1,
      mobilePaymentLength: 10,
      searchKeyword: '',
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user?.tenant_info?.tenant_id && !state.isUserReady && props?.selectedSeller) {
      const { user, getPaymentsOutgoing, selectedSeller } = props;
      getPaymentsOutgoing(1, 10, user?.tenant_info?.tenant_id, selectedSeller?.tenant_seller_id);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getPaymentsOutgoingLoading, paymentOutgoing, getPaymentsOutgoing, user, selectedSeller, getSellerByIdLoading,
    } = this.props;
    const {
      column, currentPage, selectedPayment, showViewPayout, keyword,
    } = this.state;
    return (

      <Fragment>
        <Drawer
          open={showViewPayout}
          onClose={() => this.setState({ showViewPayout: false })}
          width="880px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '825px' }}>
              <H3Text text={`View Payment #${ selectedPayment?.payment_id}`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showViewPayout: false })} />
            </div>
          </div>
          <ViewPayment
            selectedPaymentId={selectedPayment?.payment_id}
            callback={() => {
              this.setState({ showViewPayout: false });
              getPaymentsOutgoing(currentPage, 10, user?.tenant_info?.tenant_id, selectedSeller?.tenant_seller_id);
            }}
          />
        </Drawer>
        <div className="generic-table-container">
          <Table
            title={() => (
              <div className="payouts__table-header">
                {`${paymentOutgoing?.count || '0'} Payouts`}
              </div>
            )}
            showHeader
            loading={getPaymentsOutgoingLoading || getSellerByIdLoading}
            size="small"
            columns={column}
            dataSource={paymentOutgoing?.payments || []}
            currentPage
            pagination={paymentOutgoing?.count > 10 ? {
              defaultCurrent: 1,
              current: currentPage,
              total: paymentOutgoing?.count || '0',
              pageSize: 10,
              onChange: (page) => {
                getPaymentsOutgoing(page, 10, user?.tenant_info?.tenant_id, selectedSeller?.tenant_seller_id);
                this.setState({ currentPage: page });
              },
              position: ['bottomLeft'],
              showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
              showSizeChanger: false,
            } : false}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, PaymentOutgoingReducers, SellerReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPaymentsOutgoingLoading: PaymentOutgoingReducers.getPaymentsOutgoingLoading,
  paymentOutgoing: PaymentOutgoingReducers.paymentOutgoing,
  selectedSeller: SellerReducers.selectedSeller,
  getSellerByIdLoading: SellerReducers.getSellerByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentsOutgoing: (page, limit, tenantId, tenantSellerId, searchKeyword) => dispatch(PaymentOutgoingActions.getPaymentsOutgoing(page, limit, tenantId, tenantSellerId, searchKeyword)),
});

PayoutsList.propTypes = {
  getPaymentsOutgoing: PropTypes.func,
  getPaymentsOutgoingLoading: PropTypes.bool,
  getSellerByIdLoading: PropTypes.bool,
  paymentOutgoing: PropTypes.any,
  user: PropTypes.any,
  selectedSeller: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PayoutsList));
